
import './Styles/loadingAnimation.css';
const LoadingAnimation = () => {

    return  (
        <>
            <div className="loading">
            </div>
        </>
    ); 
        
}

export default LoadingAnimation;